/** @jsx jsx */
import { css } from '@emotion/core'

// Using exact colors and styling from old midsec
const primaryColor = '#243588';
const secondaryColor = '#3fae2a';
const fontFamily = 'proxima-nova, sans-serif';

export const eventFormStyle = {
  container: css`
    font-family: ${fontFamily};
  `,

  banner: css`
    text-align: center;
    margin-top: 45px;
    padding: 20px 0px;
    background: rgba(255, 255, 255, .4);
    
    @media (min-width: 576px) {
      margin-top: 50px;
    }
  `,

  bannerImage: css`
    max-height: 500px;
    max-width: 100%;
    height: auto;
  `,

  eventView: css`
    margin: 20px 0px;
    padding: 0px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    
    @media (min-width: 992px) {
      padding: 0px 30px;
    }

    @media (min-width: 1200px) {
      padding: 0px 140px;
    }
  `,

  event: css`
    /* Event styling matches old midsec event-view */
  `,

  eventType: css`
    text-align: left;
    color: #000;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-family: ${fontFamily};
  `,

  eventDetails: css`
    text-align: left;
    margin-top: 20px;
  `,

  registerHeader: css`
    text-align: left;
    margin-top: 30px;
    margin-bottom: 20px;
    color: ${primaryColor};
    font-size: 24px;
    font-weight: 700;
    font-family: ${fontFamily};
  `,

  eventTitle: css`
    color: #000;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 1.2;
    font-family: ${fontFamily};
    text-align: left;
  `,

  eventDescription: css`
    font-size: 16px;
    line-height: 1.6;
    color: #000;
    margin-bottom: 20px;
    font-family: ${fontFamily};
    text-align: left;
    
    p {
      margin-bottom: 15px;
    }
    
    ul, ol {
      margin-left: 20px;
      margin-bottom: 15px;
    }
  `,

  eventDate: css`
    font-size: 16px;
    margin-bottom: 8px;
    color: #000;
    font-family: ${fontFamily};
    text-align: left;
    
    b {
      color: ${secondaryColor};
      font-weight: 700;
    }
  `,

  eventTime: css`
    font-size: 16px;
    margin-bottom: 8px;
    color: #000;
    font-family: ${fontFamily};
    text-align: left;
    
    b {
      color: ${secondaryColor};
      font-weight: 700;
    }
  `,

  eventPlace: css`
    font-size: 16px;
    margin-bottom: 15px;
    color: #000;
    font-family: ${fontFamily};
    text-align: left;
    
    b {
      color: ${secondaryColor};
      font-weight: 700;
    }
  `,

  form: css`
    margin-top: 40px;
    max-width: 100%;
  `,

  formGroup: css`
    margin-bottom: 20px;
  `,

  label: css`
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #000;
    font-family: ${fontFamily};
  `,

  input: css`
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    font-family: ${fontFamily};
    
    &:focus {
      color: #495057;
      background-color: #fff;
      border-color: #80bdff;
      outline: 0;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  `,

  select: css`
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    font-family: ${fontFamily};
    
    &:focus {
      color: #495057;
      background-color: #fff;
      border-color: #80bdff;
      outline: 0;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  `,

  submitButton: css`
    background-color: ${primaryColor};
    color: white;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    text-decoration: none;
    border-radius: 0.25rem;
    border: 1px solid ${primaryColor};
    cursor: pointer;
    transition: all 0.15s ease-in-out;
    font-family: ${fontFamily};
    margin-top: 40px;
    display: block;
    
    &:hover {
      background-color: ${secondaryColor};
      border-color: ${secondaryColor};
      color: white;
      text-decoration: none;
    }
    
    &:focus {
      outline: 0;
      box-shadow: 0 0 0 0.2rem rgba(36, 53, 136, 0.25);
    }
    
    &:disabled {
      opacity: 0.65;
      cursor: not-allowed;
    }
  `,

  success: css`
    text-align: center;
    padding: 40px 20px;
    color: ${secondaryColor};
    font-family: ${fontFamily};
    
    h2 {
      color: ${secondaryColor};
      margin-bottom: 20px;
    }
    
    p {
      font-size: 18px;
      line-height: 1.6;
    }
  `,

  error: css`
    text-align: center;
    padding: 40px 20px;
    color: #d32f2f;
    background-color: #ffebee;
    border-radius: 4px;
    border: 1px solid #ffcdd2;
    font-family: ${fontFamily};
    margin: 20px;
  `,

  errorMessage: css`
    color: #d32f2f;
    background-color: #ffebee;
    border: 1px solid #ffcdd2;
    border-radius: 4px;
    padding: 10px;
    margin-top: 15px;
    font-family: ${fontFamily};
  `,

  resetButton: css`
    background-color: #dc3545;
    color: white;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    border: 1px solid #dc3545;
    cursor: pointer;
    transition: all 0.15s ease-in-out;
    margin-top: 10px;
    display: block;
    font-family: ${fontFamily};
    
    &:hover {
      background-color: #c82333;
      border-color: #bd2130;
    }
  `,

  fullyBookedMessage: css`
    margin: 1em 0;
    color: #d32f2f;
    margin-left: 0;
    margin-bottom: 3em;
    font-family: ${fontFamily};
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
  `
};
